import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';



export const LoadingDiv = () => {

	return (
		<div className="mdx-loading-div">
			<LoadingSpinner />
		</div>
	);
};